export const calculateResponsiveSize = px => `${px / 19.2}vw`
